module.exports = "/assets/freebies/kropla@2x.png?n7RQWWG";